export type Order = "asc" | "desc";

export function comparator<T>(a: T, b: T, orderBy: keyof T) {
	const aValue = a[orderBy];
	const bValue = b[orderBy];

	// Comparación para Date
	if (aValue instanceof Date && bValue instanceof Date) {
		return bValue.getTime() - aValue.getTime();
	}

	// Comparación para string[]
	if (Array.isArray(aValue) && Array.isArray(bValue)) {
		if (bValue.length < aValue.length) {
			return -1;
		} else if (bValue.length > aValue.length) {
			return 1;
		}
		return 0;
	}

	// Comparación genérica (números y cadenas)
	if (bValue < aValue) {
		return -1;
	} else if (bValue > aValue) {
		return 1;
	}

	return 0;
}

export function getComparator<Key extends keyof any>(
	order: Order,
	orderBy: Key,
): (
	a: { [key in Key]: number | string | Date | string[] },
	b: { [key in Key]: number | string | Date | string[] },
) => number {
	return order === "desc"
		? (a, b) => comparator(a, b, orderBy)
		: (a, b) => -comparator(a, b, orderBy);
}
